var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCircleWhiteCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#00A889"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42063 11.75C7.10257 12.0833 6.57184 12.0833 6.25378 11.75L3.23779 8.58961C2.92074 8.25737 2.92074 7.70451 3.23779 7.37227L3.89186 6.68689C4.20972 6.35381 4.72185 6.3536 5.03995 6.68626L6.84519 8.56119L10.9594 4.24997C11.2775 3.91668 11.7901 3.91668 12.1081 4.24997L12.7622 4.93535C13.0793 5.26759 13.0793 5.82045 12.7622 6.15269L7.42063 11.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircleWhiteCheck);
export default __webpack_public_path__ + "static/media/green-circle-white-check.312bd476ed8c9bb4f814ee72e66338fa.svg";
export { ForwardRef as ReactComponent };